import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=cef97130&scoped=true&"
import script from "./Door.vue?vue&type=script&lang=js&"
export * from "./Door.vue?vue&type=script&lang=js&"
import style0 from "./Door.vue?vue&type=style&index=0&id=cef97130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef97130",
  null
  
)

export default component.exports